import type { PercentCrop } from 'react-image-crop';

const getCanvasFromCrop = (image: HTMLImageElement, crop: PercentCrop) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const cropX = image.width * (0.01 * crop.x) * scaleX;
  const cropY = image.height * (0.01 * crop.y) * scaleY;
  const centerX = image.naturalWidth / 2;
  const centerY = image.naturalHeight / 2;

  canvas.width = Math.floor(image.width * (0.01 * crop.width) * scaleX);
  canvas.height = Math.floor(image.height * (0.01 * crop.height) * scaleY);
  ctx.imageSmoothingQuality = 'high';

  ctx.save();
  ctx.translate(-cropX, -cropY);
  ctx.translate(centerX, centerY);
  ctx.translate(-centerX, -centerY);
  ctx.drawImage(
    image,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
  );
  ctx.restore();

  return canvas;
};

export const getBlobFromCrop = async (...params: Parameters<typeof getCanvasFromCrop>) => {
  const canvas = getCanvasFromCrop(...params);

  return new Promise<Blob>((resolve) => {
    canvas.toBlob((canvasBlob) => {
      resolve(canvasBlob as Blob);
    });
  });
};
